// extracted by mini-css-extract-plugin
module.exports = {"header":"UserModelsTable_header__ocjBY","scrolled":"UserModelsTable_scrolled__gozbJ"};